import {Box, TextField, Typography} from '@material-ui/core';
import {ChangeEvent, FormEvent, useContext, useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router';
import {Button, EmptyTopBar, Layout, Loading} from '../../components';
import {EMAIL_VERIFICATION_PAGE, ERROR_404_PAGE} from '../../const/routes';
import {useAppDispatch, useAppSelector} from '../../hooks/customReduxHooks';
import {
    selectAuthStatus,
    selectAuthUserData,
    signOut,
    verifySMSCode,
} from '../../store/auth';
import useStyles from './PhoneVerificationPageStyles';
import AccountProvider from '../../services/accountProvider';
import useQuery from '../../hooks/useQuery';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../const/i18nNamespaces';
import {PHONE_NUMBER_CONFIRMATION} from '../../const/auth';
import { isTokenValid } from '../../utils/jwt';
import { getToken } from '../../storage/storage';
import SendCodeAgain from '../../components/common/SendCodeAgain/SendCodeAgain';
import accountProvider from '../../services/accountProvider';
import axios from 'axios';
import { AlertContext } from '../../contexts/AlertContext';
import PhoneVerificationWithTokenInQuery from '../../components/phoneVerification/PhoneVerificationWithTokenInQuery/PhoneVerificationWithTokenInQuery';
type LocationState = {
    email: string;
    isTokenFromQuery?: boolean;
};

const PhoneVerificationPage = () => {
    const {t} = useTranslation(i18nNamespaces.AUTH);
    const dispatch = useAppDispatch();
    const authUserData = useAppSelector(selectAuthUserData);
    const status = useAppSelector(selectAuthStatus);
    const [error, setError] = useState<string>('');
    const location = useLocation<LocationState>();
    const history = useHistory();
    const [code, setCode] = useState<string>('');
    const query = useQuery();
    const returnUrl = query.get('returnUrl');
    const encodedReturnUrl = '?returnUrl=' + encodeURIComponent(returnUrl);
    const localStorageToken = getToken();
    const isTokenFromQuery = location?.state?.isTokenFromQuery;
    const [calledWithCode, setCalledWithCode] = useState(false);
    const [firstCodeSent, setFirstCodeSent] = useState(false);
    const openAlert = useContext(AlertContext);
    const isBeforeFirstSendWithTokenInQuery = isTokenFromQuery && !firstCodeSent;
    const [loading, setLoading] = useState(false);

     useEffect(() => {
        // The user has token in query params, probably from Compas
        if(localStorageToken) 
        {
            if(!isTokenValid(localStorageToken)) {
                dispatch(signOut());
                history.push(ERROR_404_PAGE);
            }
        }
    }, [localStorageToken]);

    useEffect(() => {
        if (authUserData?.role !== PHONE_NUMBER_CONFIRMATION) {
            if (returnUrl && returnUrl !== 'null') {
                history.push({
                    pathname: EMAIL_VERIFICATION_PAGE,
                    state: {email: location.state.email},
                    search: encodedReturnUrl,
                });
            } else {
                history.push(EMAIL_VERIFICATION_PAGE, {email: location.state.email});
            }
        }
    }, [authUserData, history, location, returnUrl, encodedReturnUrl]);

    useEffect(() => {
        if (status === 'failed') setError(t('invalidCodeTryAgain'));
    }, [status]);

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault();
        const email = location.state?.email;
        setError('');
        dispatch(verifySMSCode({email, code}));
    };

    const onCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value);
        setError('');
    };

    const handleCallWithCode = async () => {
        setCalledWithCode(true);
    };

    

    const classes = useStyles();

    return (
        <Layout topBar={isTokenFromQuery && <EmptyTopBar />}>
            {
                isTokenFromQuery ? 
                <PhoneVerificationWithTokenInQuery email={location?.state?.email} /> : (
                <div className={classes.container}>
                    <Loading loading={status === 'loading'} withBackdrop />
                    <Box
                        py={3}
                        justifyContent="center"
                        alignItems="center"
                        display={'flex'}
                        flexDirection="column"
                    >
                        <Typography variant={'h3'}>
                            {t('phoneNumberVerification')}
                        </Typography>
                        <Box component="span" pt={2} pb={4}>
                            {
                                calledWithCode ? t('weWillCallYouWithCode') : t('smsWithVerificationCodeWasSend')
                            }
                        </Box>
                        
                            <form onSubmit={onSubmit}>
                                <Box mb={1}>
                                    <TextField
                                        className={classes.input}
                                        label={calledWithCode ? t('enterCodeFromCall') : t('enterCodeFromSMS')}
                                        type="text"
                                        id="SMSCode"
                                        variant="outlined"
                                        value={code}
                                        onChange={onCodeChange}
                                        autoComplete="off"
                                        error={!!error}
                                        helperText={error && error}
                                        autoFocus
                                    />
                                </Box>
                                <SendCodeAgain mt={0} mb={2} onCallWithCode={handleCallWithCode}/>
                                <Button
                                    color="secondary"
                                    variant="contained"
                                    type="submit"
                                    className={classes.button}
                                    disabled={!code}
                                >
                                    {t('next')}
                                </Button>
                            </form>
                        
                    </Box>
                </div>
                )
            }
            
        </Layout>
    );
};

export default PhoneVerificationPage;
